export interface BusinessHoursInterface {
    mon: string[][];
    tue: string[][];
    wed: string[][];
    thu: string[][];
    fri: string[][];
    sat: string[][];
    sun: string[][];
}

export const DEFAULT_BUSINESS_HOURS: BusinessHoursInterface = {
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: []
}
